import React from 'react';
import { Redirect } from 'react-router';
import { providerChartsReviewRoute, ROUTING_CONFIG } from '@uplift/constants';
import { useCollaboratePhysicianMatchQuery, useCollaborativeChartsReviewQuery } from '@uplift/queries';
import { ProviderLayout } from '@uplift/ui-v2';

import { ChartsReviewSection } from './components/ChartsReviewSection';
import { ErrorBoundary } from 'react-error-boundary';
import { useCurrentuser } from '@uplift/contexts';


const ChartsReviewPageContent: React.VFC = () => {
  const { reviewId } = providerChartsReviewRoute.useParams();
  const { data: chartsReview } = useCollaborativeChartsReviewQuery(reviewId);
  const { data: collaborativeMatch } = useCollaboratePhysicianMatchQuery(chartsReview.matchId);

  return (
    <ChartsReviewSection
      collaborativeMatch={collaborativeMatch}
      chartsReview={chartsReview}
    />
  );
};

export const ChartsReviewPage: React.VFC = () => {
  const me = useCurrentuser();

  if (!me.isCollaborativePhysician) {
    return <Redirect to={ROUTING_CONFIG.main} />;
  }

  return (
    <ProviderLayout bodyScroll={true}>
      <ErrorBoundary
        fallback={<Redirect to={ROUTING_CONFIG.chartsReviews} />}
      >
        <ChartsReviewPageContent />
      </ErrorBoundary>
    </ProviderLayout>
  );
};
